import { ColumnsType } from 'antd/lib/table';
import { SortOrder } from 'antd/lib/table/interface';
import { TranslationKey, useTranslate } from 'hooks/use-translation';
import { TableFieldTypes } from '../components';
import { toColumnDef } from '../utils';

interface BillableType {
  value: number;
  percentage: number;
}

export interface TimeTrackedTemplateRecord {
  templateName: string;
  plannedEffort: number;
  plannedEffortPercentage: number;
  avgHoursTracked: number;
  excessHoursPlanned: number;
  averageBillingTracked: BillableType;
  averageNonBillingTracked: BillableType;
}

export const useTimeTrackedTemplateColumn =
  (): ColumnsType<TimeTrackedTemplateRecord> => {
    const translate = useTranslate();
    const getColumnTitle = (suffix: string) =>
      translate(
        `reports.template_insight.time_tracked_vs_planned.task.table.${suffix}` as TranslationKey,
      );

    return [
      {
        key: 'templateName',
        fieldType: TableFieldTypes.String,
        defaultSortOrder: 'ascend' as SortOrder,
      },
      {
        key: 'plannedEffort',
        fieldType: TableFieldTypes.Time,
      },
      {
        key: 'avgHoursTracked',
        fieldType: TableFieldTypes.Time,
      },
      {
        key: 'plannedEffortPercentage',
        fieldType: TableFieldTypes.Percentage,
      },
      {
        key: 'excessHoursPlanned',
        fieldType: TableFieldTypes.Time,
      },
      {
        key: 'averageBillingTracked',
        fieldType: TableFieldTypes.TimeWithPercentage,
      },
      {
        key: 'averageNonBillingTracked',
        fieldType: TableFieldTypes.TimeWithPercentage,
      },
    ].map((x) => toColumnDef(x, getColumnTitle));
  };

export interface TimeTrackedTaskRecord {
  taskName: string;
  phase: string;
  templateName: string;
  plannedEffort: number;
  plannedEffortPercentage: number;
  avgHoursTracked: number;
  excessHoursPlanned: number;
  averageBillingTracked: BillableType;
  averageNonBillingTracked: BillableType;
}

export const useTimeTrackedTaskColumn =
  (): ColumnsType<TimeTrackedTaskRecord> => {
    const translate = useTranslate();
    const getColumnTitle = (suffix: string) =>
      translate(
        `reports.template_insight.time_tracked_vs_planned.task.table.${suffix}` as TranslationKey,
      );

    return [
      {
        key: 'taskName',
        fieldType: TableFieldTypes.String,
        defaultSortOrder: 'ascend' as SortOrder,
      },
      {
        key: 'templateName',
        fieldType: TableFieldTypes.String,
      },
      {
        key: 'phase',
        fieldType: TableFieldTypes.String,
      },
      {
        key: 'plannedEffort',
        fieldType: TableFieldTypes.Time,
      },
      {
        key: 'avgHoursTracked',
        fieldType: TableFieldTypes.Time,
      },
      {
        key: 'plannedEffortPercentage',
        fieldType: TableFieldTypes.Percentage,
      },
      {
        key: 'excessHoursPlanned',
        fieldType: TableFieldTypes.Time,
      },
      {
        key: 'averageBillingTracked',
        fieldType: TableFieldTypes.TimeWithPercentage,
      },
      {
        key: 'averageNonBillingTracked',
        fieldType: TableFieldTypes.TimeWithPercentage,
      },
    ].map((x) => toColumnDef(x, getColumnTitle));
  };
